module.exports = __webpack_public_path__ + "static/media/primer.acca2300.pdf";